module.exports = __webpack_public_path__ + "img/erik-arbores-thumb.e111cb15.jpg";